import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FormTypeServices from "./FormType.services"
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetFormType = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: true,
    });
    dispatch({
      type: actions.GET_FORM_TYPE,
      payload: {
        formTypes: [],
        formTypesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: false,
    });
  }
};

export const getFormType = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: true,
    });
    const resp = await FormTypeServices.getFormType(filters);
    dispatch({
      type: actions.GET_FORM_TYPE,
      payload: {
        formTypes: resp.data.data || [],
        formTypesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: false,
    });
  }
};

export const getFormTypeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FORM_TYPE_BY_ID,
      payload: true,
    });
    const resp = await FormTypeServices.getFormTypeById(id);
    dispatch({
      type: actions.GET_FORM_TYPE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FORM_TYPE_BY_ID,
      payload: false,
    });
  }
};

export const saveFormType = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FORM_TYPE,
      payload: true,
    });
    const resp = await FormTypeServices.saveFormType(data);
    const { formTypes, formTypesLength } = getState().formType;
    const _formTypes = [...formTypes, resp.data];
    dispatch({
      type: actions.GET_FORM_TYPE,
      payload: {
        formTypes: _formTypes,
        formTypesLength: formTypesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FORM_TYPE,
      payload: false,
    });
  }
};

export const editFormType = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FORM_TYPE,
      payload: true,
    });
    const resp = await FormTypeServices.editFormType(id, data);
    const { formTypes, formTypesLength } = getState().formType;
    formTypes[index] = resp.data;
    dispatch({
      type: actions.GET_FORM_TYPE,
      payload: {
        formTypes: formTypes,
        formTypesLength: formTypesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FORM_TYPE,
      payload: false,
    });
  }
};

export const deleteFormType = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: true,
    });
    await FormTypeServices.deleteFormType(id);
    const { formTypes, formTypesLength } = getState().formType;
    formTypes.splice(index, 1);
    dispatch({
      type: actions.GET_FORM_TYPE,
      payload: {
        formTypes: formTypes,
        formTypesLength: formTypesLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_TYPE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FORM_TYPE,
      payload: false,
    });
  }
};
